// actions.js
import {
  FETCH_CONFIGURATIONS_REQUEST,
  FETCH_CONFIGURATIONS_SUCCESS,
  FETCH_CONFIGURATIONS_FAILURE,
  DELETE_CONFIGURATIONS_REQUEST,
  DELETE_CONFIGURATIONS_FAILURE,
  DELETE_CONFIGURATIONS_SUCCESS,
  FETCH_CONFIGURATION_REQUEST,
  FETCH_CONFIGURATION_SUCCESS,
  FETCH_CONFIGURATION_FAILURE,
  UPDATE_CONFIGURATIONS_REQUEST,
  UPDATE_CONFIGURATIONS_SUCCESS,
  UPDATE_CONFIGURATIONS_FAILURE,
  DUPLICATE_CONFIGURATIONS_REQUEST,
  DUPLICATE_CONFIGURATIONS_FAILURE,
  DUPLICATE_CONFIGURATIONS_SUCCESS,
  OPEN_EDIT_PAGE_CONFIGURATION,
  OPEN_EDIT_PAGE_CONFIGURATION_SUCCESS,
  CHECK_CONFIGURATION_REQUEST,
  CHECK_CONFIGURATION_SUCCESS,
  CHECK_CONFIGURATION_FAILURE,
  VERIFY_CONFIGURATION_REQUEST,
  VERIFY_CONFIGURATION_SUCCESS,
  VERIFY_CONFIGURATION_FAILURE,
  CLEAR_CONFIGURATION_ERRORS,
  CLEAR_CONFIGURATION_SUCCESS,
  CLEAR_VERIFY_CONFIGURATION_ERRORS,
  CLEAR_VERIFY_CONFIGURATION_SUCCESS,
  CHECK_CONFIGURATIONS_EXPIRED_REQUEST,
  CHECK_CONFIGURATIONS_EXPIRED_SUCCESS,
  CHECK_CONFIGURATIONS_EXPIRED_FAILURE,
} from './actionTypes';

export const fetchConfigurationsRequest = () => ({
  type: FETCH_CONFIGURATIONS_REQUEST,
});

export const fetchConfigurationsSuccess = (configurations) => ({
  type: FETCH_CONFIGURATIONS_SUCCESS,
  payload: configurations,
});

export const fetchConfigurationsFailure = (error) => ({
  type: FETCH_CONFIGURATIONS_FAILURE,
  payload: error,
});

export const fetchConfigurationRequest = (id) => ({
  type: FETCH_CONFIGURATION_REQUEST,
  payload: id
});

export const fetchConfigurationSuccess = (project) => ({
  type: FETCH_CONFIGURATION_SUCCESS,
  payload: project,
});

export const fetchConfigurationFailure = (error) => ({
  type: FETCH_CONFIGURATION_FAILURE,
  payload: error,
});

export const updateConfigurationRequest = (configuration, navigate, toConfig) => {
  return {
  type: UPDATE_CONFIGURATIONS_REQUEST,
  payload: { configuration, navigate, toConfig }
}};

export const updateConfigurationSuccess = () => ({
  type: UPDATE_CONFIGURATIONS_SUCCESS,
});

export const updateConfigurationFailure = (error) => ({
  type: UPDATE_CONFIGURATIONS_FAILURE,
  payload: error,
});

export const deleteConfigurationRequest = (id) => ({
  type: DELETE_CONFIGURATIONS_REQUEST,
  payload: id
});

export const deleteConfigurationSuccess = (id) => ({
  type: DELETE_CONFIGURATIONS_SUCCESS,
  payload: id,
});

export const deleteConfigurationFailure = (error) => ({
  type: DELETE_CONFIGURATIONS_FAILURE,
  payload: error,
});

export const duplicateConfigurationRequest = (id, configDuplicate) => ({
  type: DUPLICATE_CONFIGURATIONS_REQUEST,
  payload: {id, configDuplicate}
});

export const duplicateConfigurationSuccess = (id) => ({
  type: DUPLICATE_CONFIGURATIONS_SUCCESS,
  payload: id,
});

export const duplicateConfigurationFailure = (error) => ({
  type: DUPLICATE_CONFIGURATIONS_FAILURE,
  payload: error,
});

export const openEditPageConfiguration = (id, navigate) => ({
  type: OPEN_EDIT_PAGE_CONFIGURATION,
  payload: { id, navigate }
});

export const openEditPageConfigurationSuccess = () => ({
  type: OPEN_EDIT_PAGE_CONFIGURATION_SUCCESS,
});


export const checkConfigurationRequest = (config) => ({
  type: CHECK_CONFIGURATION_REQUEST,
  payload: config,
});

export const checkConfigurationSuccess = (config) => ({
  type: CHECK_CONFIGURATION_SUCCESS,
  payload: config
});

export const checkConfigurationFailure = (error) => ({
  type: CHECK_CONFIGURATION_FAILURE,
  payload: error,
});

export const verifyConfigurationRequest = (config) => ({
  type:  VERIFY_CONFIGURATION_REQUEST,
  payload: config,
});

export const verifyConfigurationSuccess = (config) => ({
  type:  VERIFY_CONFIGURATION_SUCCESS,
  payload: config
});

export const verifyConfigurationFailure = (error) => ({
  type:  VERIFY_CONFIGURATION_FAILURE,
  payload: error,
});

export const clearVerifyConfigurationErrors = () => ({
  type: CLEAR_VERIFY_CONFIGURATION_ERRORS,
});

export const clearVerifyConfigurationSuccess = () => ({
  type: CLEAR_VERIFY_CONFIGURATION_SUCCESS,
});

export const clearConfigurationErrors = () => ({
  type: CLEAR_CONFIGURATION_ERRORS,
});

export const clearConfigurationSuccess = () => ({
  type: CLEAR_CONFIGURATION_SUCCESS,
});

export const checkConfigurationsExpiredRequest = () => ({
  type: CHECK_CONFIGURATIONS_EXPIRED_REQUEST,
});

export const checkConfigurationsExpiredSuccess = () => ({
  type: CHECK_CONFIGURATIONS_EXPIRED_SUCCESS,
});

export const checkConfigurationsExpiredFailure = (error) => ({
  type: CHECK_CONFIGURATIONS_EXPIRED_FAILURE,
  payload: error,
});